export default __webpack_public_path__ + "static/media/image.eota-tech-pvt-ltd.13e2e849.png";